export default "__VITE_PUBLIC_ASSET__bfd8b228__"